<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div class="top">
        <div class="header">
          <a href="/">
            <!-- <img src="~@/assets/img/qd-logo.png" class="logo" alt="logo"> -->
          </a>
          <span class="title">{{title}}</span>
        </div>
        <!-- <div class="desc">
          专注于车险电销的CRM
        </div> -->
      </div>
      <div class="main">
        <div class="exhibition">
          <img src="/static/img/truck.jpeg" class="cover" alt="cover">
        </div>
        <route-view></route-view>
      </div>
      <div class="footer">
        <div class="links">
          <!-- <a href="javascript:;" @click="$refs.agreement.show()">服务协议</a> -->
        </div>
        <div class="copyright">
          Copyright &copy; 2024 平安行汽车服务有限公司
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RouteView from '@/components/Layouts/RouteView'
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    name: 'UserLayout',
    components: { 
      RouteView,
    },
    mixins: [mixinDevice],
    data () {
      return {}
    },
    mounted () {
      document.body.classList.add('userLayout')
    },
    computed: {
      title() {
        return this.$route ? this.$route.meta.title : "";
      },
    },
    beforeDestroy () {
      document.body.classList.remove('userLayout')
    },
  }
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      background: #f0f2f5;
      position: relative;
      padding-bottom: 144px;

      a {
        text-decoration: none;
      }

      .top {
        text-align: left;
        background: white;

        .header {
          width: 90%;
          margin: 0 auto;
          padding: 24px 0;
          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 30px;
            padding:0 15px;
            color: rgba(0, 0, 0, .85);
            font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-weight: 600;
            border-left: 1px solid #999;
            position: relative;
            top: 2px;
            
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        display: flex;
        width: 90%;
        height: 550px;
        margin:0 auto;
        margin-top: 100px;
        .cover{
          width: 100%;
          height: 100%;
        }
        .exhibition{
          flex: 1;
        }
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Layouts/UserLayout.vue